import { Offerte } from "../model/offerte";
import { Soglie } from "../model/soglie";

export class irenGasSicuro {
  public static  offerta ():Offerte {
      return {
		Flg_Indicizzato: false,
        Id_Offerta: 109,
        Id_Foritore: 1,
        Id_comodity: 2,
        TipoContratto:2,
        NomeOfferta: "Iren GAS SICURO",
        LinkFoto: "./assets/images/offerte-iren/GAS-SICURO.jpg",
        LinkFotoLarge: "./assets/images/offerte-iren/GAS-SICURO.jpg",
        LinkFotoMid: "./assets/images/offerte-iren/GAS-SICURO.jpg",
        LinkFotoSm: "./assets/images/offerte-iren/GAS-SICURO.jpg",
        LinkFotoCarousel: "./assets/images/offerte-iren/GAS-SICURO.jpg",
        DescrizioneCarousel: "Che Offerta super",
        DescrizioneNomeOfferta: "L'offerta blocca un prezzo fisso valido per 2 anni per la tua impresa.",
        PromozioneOfferta: "",
        Sezioni: [
          {
            NomeSezione: "RISPARMIO ASSICURATO",
            DescrizioneSezione: "L'offerta Iren Gas Sicuro è dedicata ai titolari di Partita Iva con consumi di gas inferiori a 10.000 Smc/anno. PREZZO BLOCCATO PER 2 ANNI. Questa tariffa prevede l'applicazione di un prezzo fisso della materia prima gas per 2 anni di fornitura. ",
            lstPunti: []
          },
        ],
        PrezzoEle: 0.,
        PrezzoGas: 0.325,
       
        TitoloPlus: "Vantaggi assicurati",
        Plus: ["L'offerta Iren Gas Sicuro è dedicata ai titolari di Partita Iva."]
        ,schedaconfrontabilitaele:
        {
          tabellaConfrontabilita:[]
        }
        ,schedaconfrontabilitagas:  { tabellaConfrontabilita:[ { zona:1, consumoannuo:120,importo:0},{ zona:1, consumoannuo:480,importo:0},{ zona:1, consumoannuo:700,importo:0},{ zona:1, consumoannuo:1400,importo:0},{ zona:1, consumoannuo:2000,importo:0},{ zona:1, consumoannuo:5000,importo:0} ,{ zona:2, consumoannuo:120,importo:0},{ zona:2, consumoannuo:480,importo:0},{ zona:2, consumoannuo:700,importo:0},{ zona:2, consumoannuo:1400,importo:0},{ zona:2, consumoannuo:2000,importo:0},{ zona:2, consumoannuo:5000,importo:0} ,{ zona:3, consumoannuo:120,importo:0},{ zona:3, consumoannuo:480,importo:0},{ zona:3, consumoannuo:700,importo:0},{ zona:3, consumoannuo:1400,importo:0},{ zona:3, consumoannuo:2000,importo:0},{ zona:3, consumoannuo:5000,importo:0} ,{ zona:4, consumoannuo:120,importo:0},{ zona:4, consumoannuo:480,importo:0},{ zona:4, consumoannuo:700,importo:0},{ zona:4, consumoannuo:1400,importo:0},{ zona:4, consumoannuo:2000,importo:0},{ zona:4, consumoannuo:5000,importo:0} ,{ zona:5, consumoannuo:120,importo:0},{ zona:5, consumoannuo:480,importo:0},{ zona:5, consumoannuo:700,importo:0},{ zona:5, consumoannuo:1400,importo:0},{ zona:5, consumoannuo:2000,importo:0},{ zona:5, consumoannuo:5000,importo:0} ,{ zona:6, consumoannuo:120,importo:0},{ zona:6, consumoannuo:480,importo:0},{ zona:6, consumoannuo:700,importo:0},{ zona:6, consumoannuo:1400,importo:0},{ zona:6, consumoannuo:2000,importo:0},{ zona:5, consumoannuo:5000,importo:0}]}
        ,lstModalitaPagamento :["2"]
        ,scontoRid:0 
        ,TipoSoglieEle: Soglie.SoglieEle4Fasce()
        ,ImportoAnnuoLordo: 0
        ,ImportoAnnuoNetto: 0
        ,ImportoMensileLordo: 0
        ,ImportoMensileNetto: 0
        ,iscopertura: "" 
      };
    }
}


// WEBPACK FOOTER //
// ./src/app/archivioofferte/irenGasSicuro.ts